export interface TitleSectionProps {
  title: string
  descriptionTitle: string
  description: string
}

export const useTitleSection = (props: TitleSectionProps) => {
  return {
    ...props,
  }
}
